import View from './View';

export { default as getErrorMessageStyles } from './styles';

export default View;
